"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.formatTitle = formatTitle;
exports.formatValue = formatValue;

function uc_words(string) {
	return string.split(" ").map(function (word) {
		return word[0].toUpperCase() + word.slice(1);
	}).join(" ");
}

function formatTitle(value) {
	switch (value) {
		default:
			return uc_words(value.replace(/_/g, " "));

	}
}

function formatValue(value, key, row) {
	switch (key) {
		case 'budget':
		case 'value':
		case 'reorder_value':
		case 'undiscounted_value':
			return new Intl.NumberFormat('en-GB', {
				style: 'currency',
				currency: 'GBP',
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
				currencyDisplay: 'symbol'
			}).format(value);
			break;

		case 'doors':
		case 'units':
			return new Intl.NumberFormat().format(value);
			break;

		case 'avg_discount':
			return new Intl.NumberFormat('en-GB', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}).format(value * 100) + ' %';
	}

	return value;
}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/utils/display-tools.js
// module id = 120
// module chunks = 0